var exports = {
  "n": "Accordion__tk8D9L",
};

module.exports = exports;
